import type { FrRegime, MmiEngine, TaxResidency } from '@app/finance';

export const ENGINE_LABELS: Record<MmiEngine, string> = {
  'mmi-2026': 'mmi-2026 — fidèle au classeur',
  'mmi-2026-corrected': 'mmi-2026-corrected — défauts corrigés',
};

export const FR_REGIME_LABELS: Record<FrRegime, string> = {
  'micro-foncier': 'Micro-foncier',
  'foncier-reel': 'Foncier réel',
  'micro-bic': 'Micro-BIC',
  'lmnp-reel': 'LMNP réel',
  'sci-ir': "SCI à l'IR",
  'sci-is': "SCI à l'IS",
};

export const TAX_RESIDENCY_LABELS: Record<TaxResidency, string> = {
  'resident-fr': 'Résident fiscal français (17,2 %)',
  'non-resident-eea': 'Non-résident, affilié EEE (7,5 %)',
  'non-resident-other': 'Non-résident, autre cas (17,2 %)',
};
